import { differenceInWeeks, isValid } from 'date-fns';

export const isWithinLastWeek = (timestamp: string | null | undefined): boolean => {
	if (!timestamp || timestamp.trim() === '') {
		return false;
	}

	const timestampDate = new Date(timestamp);

	if (!isValid(timestampDate)) {
		return false;
	}

	return differenceInWeeks(new Date(), timestampDate) < 1;
};
